import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Set on an individual `HttpClient` call when the subscriber already surfaces an error message
 * (snackbar, dialog, inline text). Prevents duplicate toasts from {@link httpGlobalErrorSnackInterceptor}.
 */
export const SUPPRESS_GLOBAL_HTTP_ERROR_SNACK = new HttpContextToken<boolean>(() => false);

/** Use as `this.http.get(url, { context: httpContextSuppressGlobalHttpErrorSnack() })`. */
export function httpContextSuppressGlobalHttpErrorSnack(): HttpContext {
  return new HttpContext().set(SUPPRESS_GLOBAL_HTTP_ERROR_SNACK, true);
}
